module.exports = __webpack_public_path__ + "img/圣诞帽.f5ff3a5b.gif";